import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useUser } from '../../../hooks/hooks';

const Container = styled.div`
  display: flex;
`;

const MenuItem = styled.div`
  padding: 0 12px;
`;

const StyledLinkExternal = styled(LinkExternal)`
  margin-left: 8px;
  fill: #fff9;
  vertical-align: bottom;

  :hover {
    fill: #fff;
  }
`;

const StyledNavLink = styled(NavLink)`
  height: 44px;
  display: inline-block;

  &.active {
    color: #fff;
    border-bottom: 4px solid #fff;
  }
`;

export function Menu() {
  const user = useUser();

  return (
    <Container>
      <MenuItem>
        <StyledNavLink to="/collection">Collection</StyledNavLink>

        <Link
          to={`/user/${user?.uid}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          <StyledLinkExternal />
        </Link>
      </MenuItem>

      <MenuItem>
        <StyledNavLink to="retrofits">Retrofits</StyledNavLink>
      </MenuItem>

      <MenuItem>
        <a
          href="https://azurgears.netlify.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            display: 'inline-block',
            height: 44,
          }}
        >
          <AzurGearsIcon /> Gears
        </a>
      </MenuItem>
    </Container>
  );
}

function LinkExternal({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M10.604 1h4.146a.25.25 0 01.25.25v4.146a.25.25 0 01-.427.177L13.03 4.03 9.28 7.78a.75.75 0 01-1.06-1.06l3.75-3.75-1.543-1.543A.25.25 0 0110.604 1zM3.75 2A1.75 1.75 0 002 3.75v8.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0014 12.25v-3.5a.75.75 0 00-1.5 0v3.5a.25.25 0 01-.25.25h-8.5a.25.25 0 01-.25-.25v-8.5a.25.25 0 01.25-.25h3.5a.75.75 0 000-1.5h-3.5z"
      ></path>
    </svg>
  );
}

function AzurGearsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 20"
      style={{ marginRight: 4, height: 20, verticalAlign: 'middle' }}
    >
      <path
        fill="currentColor"
        d="M 1.273 1.83741 v 3.87359 c 0 0.966 0.823 1.74 1.803 1.74 h 1.088 c 0.888 0 1.632 0.765 1.632 1.674 c 0 0.458 -0.2 0.888 -0.558 1.21 L 4.565 11 a 1.762 1.762 0 0 0 0 2.491 L 6.16 15.08 c 0.315 0.322 0.78 0.5 1.252 0.5 c 0.473 0 0.93 -0.185 1.253 -0.5 l 0.694 -0.687 c 0.3 -0.337 0.73 -0.53 1.188 -0.53 c 0.916 0 1.682 0.745 1.682 1.625 v 1.088 c 0 0.966 0.773 1.796 1.754 1.796 h 2.175 c 0.974 0 1.747 -0.823 1.747 -1.796 v -1.088 c 0 -0.88 0.766 -1.625 1.682 -1.625 c 0.458 0 0.887 0.2 1.216 0.551 l 0.673 0.673 c 0.322 0.315 0.78 0.501 1.253 0.501 c 0.472 0 0.93 -0.186 1.252 -0.5 l 1.596 -1.59 a 1.771 1.771 0 0 0 0 -2.498 l -0.701 -0.687 a 1.578 1.578 0 0 1 -0.537 -1.18 c 0 -0.917 0.744 -1.675 1.632 -1.675 h 1.088 c 0.973 0 1.667 -0.766 1.667 -1.74 V 1.83741 s -4.505 1.79918 -6.904 1.80027 c -2.405 0 -4.519 -1.80527 -6.924 -1.80027 c -2.37 0.00590486 -4.443 1.80027 -6.813 1.80027 S 1.2729 1.83741 1.2729 1.83741 Z"
      >
        <animate
          repeatCount="0"
          fill="freeze"
          attributeName="d"
          dur="0"
          values="M1.273 3.753v1.958c0 .966.823 1.74 1.803 1.74h1.088c.888 0 1.632.765 1.632 1.674 0 .458-.2.888-.558 1.21L4.565 11a1.762 1.762 0 0 0 0 2.491L6.16 15.08c.315.322.78.5 1.252.5.473 0 .93-.185 1.253-.5l.694-.687c.3-.337.73-.53 1.188-.53.916 0 1.682.745 1.682 1.625v1.088c0 .966.773 1.796 1.754 1.796h2.175c.974 0 1.747-.823 1.747-1.796v-1.088c0-.88.766-1.625 1.682-1.625.458 0 .887.2 1.216.551l.673.673c.322.315.78.501 1.253.501.472 0 .93-.186 1.252-.5l1.596-1.59a1.771 1.771 0 0 0 0-2.498l-.701-.687a1.578 1.578 0 0 1-.537-1.18c0-.917.744-1.675 1.632-1.675h1.088c.973 0 1.667-.766 1.667-1.74V3.753s-4.505-2.032-6.904-2.03c-2.405 0-4.519 2.025-6.924 2.03-2.37.005-4.443-2.03-6.813-2.03s-6.813 2.03-6.813 2.03z;M1.273 1.636v4.075c0 .966.823 1.74 1.803 1.74h1.088c.888 0 1.632.765 1.632 1.674 0 .458-.2.888-.558 1.21L4.565 11a1.762 1.762 0 0 0 0 2.491L6.16 15.08c.315.322.78.5 1.252.5.473 0 .93-.185 1.253-.5l.694-.687c.3-.337.73-.53 1.188-.53.916 0 1.682.745 1.682 1.625v1.088c0 .966.773 1.796 1.754 1.796h2.175c.974 0 1.747-.823 1.747-1.796v-1.088c0-.88.766-1.625 1.682-1.625.458 0 .887.2 1.216.551l.673.673c.322.315.78.501 1.253.501.472 0 .93-.186 1.252-.5l1.596-1.59a1.771 1.771 0 0 0 0-2.498l-.701-.687a1.578 1.578 0 0 1-.537-1.18c0-.917.744-1.675 1.632-1.675h1.088c.973 0 1.667-.766 1.667-1.74V1.636s-4.505 2.202-6.904 2.203c-2.405 0-4.519-2.208-6.924-2.203-2.37.006-4.443 2.203-6.813 2.203S1.273 1.636 1.273 1.636z;M1.273 3.753v1.958c0 .966.823 1.74 1.803 1.74h1.088c.888 0 1.632.765 1.632 1.674 0 .458-.2.888-.558 1.21L4.565 11a1.762 1.762 0 0 0 0 2.491L6.16 15.08c.315.322.78.5 1.252.5.473 0 .93-.185 1.253-.5l.694-.687c.3-.337.73-.53 1.188-.53.916 0 1.682.745 1.682 1.625v1.088c0 .966.773 1.796 1.754 1.796h2.175c.974 0 1.747-.823 1.747-1.796v-1.088c0-.88.766-1.625 1.682-1.625.458 0 .887.2 1.216.551l.673.673c.322.315.78.501 1.253.501.472 0 .93-.186 1.252-.5l1.596-1.59a1.771 1.771 0 0 0 0-2.498l-.701-.687a1.578 1.578 0 0 1-.537-1.18c0-.917.744-1.675 1.632-1.675h1.088c.973 0 1.667-.766 1.667-1.74V3.753s-4.505-2.032-6.904-2.03c-2.405 0-4.519 2.025-6.924 2.03-2.37.005-4.443-2.03-6.813-2.03s-6.813 2.03-6.813 2.03z;"
        ></animate>
      </path>
    </svg>
  );
}
